<template>
  <div class="kinds-of-porn-we-watch">
    <span class="bg-sticker star-nude-large d-none d-md-inline-block">
      <img v-lazy="starNudeDarkSticker" :alt="`sticker star nude`" width="24" height="24" />
    </span>

    <span class="bg-sticker star-nude d-none d-md-inline-block">
      <img v-lazy="starNudeDarkSticker" :alt="`sticker star nude`" width="16" height="16" />
    </span>

    <span class="bg-sticker star-pink d-none d-md-inline-block">
      <img v-lazy="starPinkDarkSticker" :alt="`sticker star pink`" width="24" height="24" />
    </span>

    <div class="row">
      <div class="col-md-6 heading">
        <h2>{{ t("Making the kind of porn we want to watch") }}</h2>

        <img class="d-none d-md-block" :src="popUpWindowSticker" :alt="`sticker popup`" width="230" height="136" />
      </div>

      <div id="accordion" class="col-md-6 accordion">
        <div class="accordion-item">
          <h1 data-bs-toggle="collapse" data-bs-target="#first" aria-expanded="true" aria-controls="first">
            {{ t("Female Gaze") }}
            <i class="icon icon-angle-right" />
          </h1>
          <div id="first" class="collapse show" data-bs-parent="#accordion">
            {{
              t(
                "For so long, women were only in-front of the camera and we're so proud to be a company that puts women at the helm. From producer and camera, to editor and quality control, women make this magic. Plus, who better to capture pleasure on film, create a safe space for connection, openness and sensuality?",
              )
            }}
          </div>
        </div>
        <div class="accordion-item">
          <h1 class="collapsed" data-bs-toggle="collapse" data-bs-target="#second" aria-expanded="false" aria-controls="second">
            {{ t("If it's not a 'Fuck Yes'...") }}
            <i class="icon icon-angle-right" />
          </h1>
          <div id="second" class="collapse" data-bs-parent="#accordion">
            {{
              t(
                "it's a fuck no. We don't want to watch someone have sex they don't enjoy, and we're sure you don't either. That's why we frame our shoots around the desires of the performer. We have in depth chats with performers when planning the shoot then again on the day, because someone can always change their mind. That's what makes our job so fun, we get to make fantasies a reality!",
              )
            }}
          </div>
        </div>
        <div class="accordion-item">
          <h1 class="collapsed" data-bs-toggle="collapse" data-bs-target="#third" aria-expanded="false" aria-controls="third">
            {{ t("Real, Fun, Authentic Sex") }}
            <i class="icon icon-angle-right" />
          </h1>
          <div id="third" class="collapse" data-bs-parent="#accordion">
            {{
              t(
                "Sex shouldn't be intimidating, it's meant to be fun, so even the most sensual, sexy moments should feel relatable and beautiful to watch. We want to show the kind of sex you could be having, just with better lighting! Real people, real bodies, real moans, real consent, real orgasms.",
              )
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import starNudeDarkSticker from "@/assets/v2/images/stickers/star-nude-dark.svg";
import starPinkDarkSticker from "@/assets/v2/images/stickers/star-pink-dark.svg";
import popUpWindowSticker from "@/assets/v2/images/stickers/pop-up-window.svg";

defineOptions({
  name: "kinds-of-porn-we-watch",
});
const { t } = useI18n();
</script>

<style lang="scss">
@import "./index.scss";
</style>
